export const MATH_QUEST_3_QUESTIONS = [
  {
    id: 'mq3_1',
    text: '351 x 6',
    category: 'Math Quest 3',
    grade_level: '2B-2C',
    correct_answer: '2106',
    options: ['2106', '2006', '2160', '2016'],
  },
  {
    id: 'mq3_2',
    text: '1/4 + 1/2 = ?',
    category: 'Math Quest 3',
    grade_level: '2B-2C',
    correct_answer: '3/4',
    options: ['1/4', '1/2', '3/4', '2/3'],
  },
  {
    id: 'mq3_3',
    text: '532 divided by 4',
    category: 'Math Quest 3',
    grade_level: '2B-2C',
    correct_answer: '133',
    options: ['133', '132', '134', '123'],
  },
  {
    id: 'mq3_4',
    text: '0.5 + 0.3 = ?',
    category: 'Math Quest 3',
    grade_level: '2B-2C',
    correct_answer: '0.8',
    options: ['0.6', '0.7', '0.8', '0.9'],
  },
  {
    id: 'mq3_5',
    text: 'What is 2/3 of 18?',
    category: 'Math Quest 3',
    grade_level: '2B-2C',
    correct_answer: '12',
    options: ['9', '10', '12', '14'],
  },
  {
    id: 'mq3_opt_1',
    text: 'Which is larger?',
    category: 'Math Quest 3',
    grade_level: '2B-2C',
    options: ['3/5', '2/3', '1/2', '3/8'],
    correct_answer: '2/3',
  },
];
